// Types
import {
  TrackingEventsEnum,
  TrackingLinkEventReturnType,
  TrackingViewEventReturnType,
} from '@openbank/ziniaweb-ui-core-models';

const UPLOAD_ID_PAGE_DISPLAYED_TRACKING: TrackingViewEventReturnType = {
  payload: {
    pageName: '/IDValidation/step_2',
    sectionFamily: 'customer',
    sectionCategory: 'orders',
    sectionName: 'lending',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    processType: 'IDValidation',
    processStep: 'step_2',
  },
  type: TrackingEventsEnum.VIEW,
};

const UPLOAD_ID_CONTINUE_BUTTON_CLICK_TRACKING: TrackingLinkEventReturnType = {
  payload: {
    action: 'continue',
    format: 'button',
    component: 'navigationFooter',
    element: 'takeAPhoto',
    pathname: '/',
    eventCategory: 'UploadIdLandingView',
    eventAction: 'clickButton',
    eventLabel: 'takeAPhotoButton',
  },
  type: TrackingEventsEnum.LINK,
};

export { UPLOAD_ID_PAGE_DISPLAYED_TRACKING, UPLOAD_ID_CONTINUE_BUTTON_CLICK_TRACKING };
